import styled from 'styled-components'

export const AceEditorWrapper = styled.div<{ $withPrefix?: boolean; $height?: string }>`
  height: ${({ $height }) => $height};
  border-radius: ${({ theme }) => theme.size.border.radius['04']};
  overflow: hidden;

  & div {
    font-family: monospace;
  }
  & span {
    font-family: monospace;
  }

  ${({ $withPrefix, theme }) =>
    $withPrefix &&
    `
    .ace_layer {
      .ace_line {
        &:first-of-type {
          background-color: ${theme.color.background.disabled};
          opacity: 0.4;
        }
      }
    }
  `}
`
